import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { styled } from '../../../core/theme/styled';

export const Subtitle = styled(Box)`
  font-size: ${(props) => props.theme.sizes.normal};
  color: ${(props) => props.theme.configuration.secondaryTextColor};
`;
